import { MODAL_ERROR, MODAL_SUCCESS } from "../assets/_const";
import Modal from "./Modal";
import axios from "axios";

const SUBSCRIBE_POPUP_HEADER = "js-subscribe-modal__header";

/**
 * Абстрактный класс для форм на страницах подписки/отписки
 * Наследуемые классы должны иметь методы _setElems(), _getBody(), _toggleDisable(), _reset() и свойство url.
 */
export default class AbstractSubscriptionForm {
    constructor(formElem) {
        if (this.constructor === AbstractSubscriptionForm) {
            throw new Error("Abstract classes can't be instantiated.");
        }

        this.elem = formElem;

        if (this.elem) {
            this._setElems();
            this._setHandlers();
        }
    }

    _showFormResult(is_success) {
        this._toggleDisable(false);

        // берет успешное модальное окно или не успешное
        const modalClass = is_success ? MODAL_SUCCESS : MODAL_ERROR;
        const modal = document.querySelector(`.${modalClass}`).innerHTML;

        new Modal({
            content: modal,
            id: "modal",
            isNotCustom: true,
        });
    }

    _formSubmitHandler(evt) {
        evt.preventDefault();

        this._toggleDisable(true);

        axios
            .post(
                `${window.server_config.app_url}/${this.url}`,
                this._getBody(),
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                },
            )
            .then((data) => {
                this._showFormResult(true);
                this._setModalText(data.data.message);
                this._reset();
            })
            .catch((error) => {
                this._showFormResult(false);
                console.error("error", error);
            });
    }

    _setModalText(text) {
        const modalHeader = document.querySelector(`.${SUBSCRIBE_POPUP_HEADER}`);
        if (modalHeader) modalHeader.innerHTML = text
    }

    _setHandlers() {
        this.elem.addEventListener("submit", this._formSubmitHandler.bind(this));
    }
}
